import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import animationStyles from 'components/util/animation/animation.module.scss'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import styles from './Page.module.scss'

/**
 * The `Page`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Page = forwardRef((props, forwardedRef) => {
  const { Tag, children, className, useReveal, ...rest } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () =>
      classNames(
        className,
        styles.container,
        useReveal && animationStyles.fadeUp
      ),
    [className, useReveal]
  )

  return (
    <Tag ref={ref} className={classNameOutput} {...rest}>
      {children}
    </Tag>
  )
})

// Display name
Page.displayName = 'Page'

/** @type {object} */
Page.propTypes = {
  children: PropTypes.node,
  Tag: PropTypes.elementType,
  className: PropTypes.string,
  useReveal: PropTypes.bool
}

/** @type {object} */
Page.defaultProps = {
  Tag: 'section',
  className: '',
  useReveal: true
}

// Memoize
export default memo(Page)
